import React from 'react'

function Eye() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <path
                fill="currentColor"
                d="M19.242 8.05c-.075-.1-4.075-4.717-9.242-4.717-3.333 0-6.666 1.85-9.241 4.717a2.883 2.883 0 000 3.891c3.716 4.1 7.4 4.725 9.241 4.725 1.842 0 5.559-.658 9.242-4.725a2.883 2.883 0 000-3.891zm-1.233 2.783c-.084.1-3.667 4.275-8.009 4.167-4.108-.1-7.1-3.167-8.016-4.167a1.233 1.233 0 010-1.667C3.959 7 6.942 4.933 10 5c3.692-.084 7.017 3.083 8.009 4.166a1.225 1.225 0 010 1.667z"
            ></path>
            <path
                fill="currentColor"
                d="M10 6.666h-.325a.208.208 0 00-.166.117.208.208 0 000 .208 1.667 1.667 0 01-1.384 2.592 1.667 1.667 0 01-1.041-.375.2.2 0 00-.2 0 .192.192 0 00-.134.15c-.05.21-.079.425-.083.641A3.333 3.333 0 1010 6.666z"
            ></path>
        </svg>
    )
}

export default Eye
